import React, { useState } from 'react';

import AIAlertsModal from '@components/pages/AI/DeepResearch/Chatbot/Controls/AIAlertsModal';
import ListItem from '@components/pages/AI/DeepResearchSettings/AiThreadListItem';
import { useAiAlertSubscriptionUpdate } from '@hooks/useAiAlertSubscriptionUpdate';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, ContentType, TrackingLocation, click } from '@tracking';
import { AiAlertSubscription } from '@utils/backend-api/aiAlertSubscriptions';

import { VIEW_THREAD } from '../constants';

interface AiAlertSubscriptionItemProps {
  aiAlertSubscription: AiAlertSubscription;
}

const AiAlertSubscriptionItem = ({ aiAlertSubscription }: AiAlertSubscriptionItemProps) => {
  const { updateAiAlertSubscription, isUpdatingAiAlertSubscription } = useAiAlertSubscriptionUpdate(
    {}
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { trackEvent } = useEventTracking({
    contentId: aiAlertSubscription.aiThread.id,
    contentType: ContentType.AiThread,
  });
  const { Track } = useEventTracking({
    location: TrackingLocation.AiAlertModal,
  });

  const handleModalOpen = () => {
    setIsModalOpen(true);
    trackEvent(click({ clickTarget: ClickTarget.Open, clickText: 'modal' }));
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleUnsubscribe = () => {
    updateAiAlertSubscription(
      {
        id: aiAlertSubscription.id,
        unsubscribedAt: new Date(),
      },
      {
        onSuccess: handleModalClose,
      }
    );
  };

  const trackViewClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.ViewAiThread, clickText: VIEW_THREAD }));
  };

  return (
    <>
      <ListItem
        title={aiAlertSubscription.aiThread.title}
        date={aiAlertSubscription.createdAt}
        threadId={aiAlertSubscription.aiThread.id}
        onViewThreadClick={trackViewClick}
        onActionClick={handleModalOpen}
        actionAriaLabel="Unsubscribe from AI alert"
      >
        <Track>
          <AIAlertsModal
            handleNotificationSubscribeClick={null}
            handleNotificationUnsubscribeClick={handleUnsubscribe}
            isLoading={isUpdatingAiAlertSubscription}
            isOpen={isModalOpen}
            isSubscribed
            onClose={handleModalClose}
          />
        </Track>
      </ListItem>
    </>
  );
};

export default AiAlertSubscriptionItem;
